import { useEffect, useState } from "react";

export default function OpenNotifications() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const notificationShown = localStorage.getItem("notificationShown");
        if (!notificationShown && Notification.permission !== "denied") {
            setOpen(true);
        }
    }, []);

    const requestPermission = () => {
        Notification.requestPermission().then((permission) => {
            if (permission === "granted") {
                setOpen(false);
                localStorage.setItem("notificationShown", "true");
            } else {
                setOpen(false);
            }
        });
    };

    const closeNotification = () => {
        setOpen(false);
        localStorage.setItem("notificationShown", "true");
    };

    return (
        <>
            {open && (
                <div className="w-screen bg-gradient-to-r from-blue-600 to-blue-400 cursor-pointer sm:-ml-4 sm:-mr-4">
                    <div className="flex items-center justify-between w-full font-medium py-1">
                        <div className="flex items-center justify-center w-full">
                            <p className="text-white text-sm">
                                Enable notifications to get the best experience.
                            </p>
                            <div className="flex items-center">
                                <button
                                    onClick={requestPermission}
                                    className="text-white font-semibold border px-4 rounded-lg text-sm ml-4"
                                >
                                    Enable
                                </button>
                            </div>
                        </div>
                        <button
                            onClick={closeNotification}
                            className="text-white font-semibold px-2 mr-4 rounded-lg text-sm"
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}